import { morph, MORPH_DEFAULTS } from '@scale/morph';
import { parseSectionHTML } from '@scale/utilities';

const SECTION_PREFIX = 'shopify-section-';

export function morphSection(sectionId, html, mode = 'full') {
  const selector = `${SECTION_PREFIX}${sectionId}`;
  const existing = document.getElementById(selector);
  if (!existing) return;

  const doc = parseSectionHTML(html);
  const incoming = doc.getElementById(selector);
  if (!incoming) return;

  morph(existing, incoming, {
    ...MORPH_DEFAULTS,
    hydrationMode: mode === 'hydration',
  });
}
